module.exports = __webpack_public_path__ + "img/1-2.cbc0971f.jpg";